import { useEffect, useState } from "react";
import { getTenderhubApi } from "../../../api/api";
import type { TTenderhub } from "../../../types/tenderhub";
import TenderhubAwardsSection from "./tenderhub-awards-section";
import TenderhubMediaSection from "./tenderhub-media-section";
import TenderhubReviewsSection from "./tenderhub-reviews-section";
import TenderhubShowreelSection from "./tenderhub-showreel-section";
import TenderhubSupplierCardSection from "./tenderhub-supplier-card-section";
import "./tenderhub-content-list.sass";

const TenderhubContentList = () => {
  const [tenderhub, setTenderhub] = useState<TTenderhub | null>(null);

  useEffect(() => {
    getTenderhubApi()
      .then((res) => {
        setTenderhub(res?.data ?? null);
      })
      .catch(() => {
        setTenderhub(null);
      });
  }, []);

  return (
    <div className="tenderhub-content-list">
      <TenderhubReviewsSection reviewsSection={tenderhub?.reviews_section} />
      <TenderhubMediaSection items={tenderhub?.media_publications} />
      <TenderhubAwardsSection items={tenderhub?.industry_recognitions} />
      <TenderhubSupplierCardSection />
      <TenderhubShowreelSection showreel={tenderhub?.showreel} />
    </div>
  );
};

export default TenderhubContentList;
